module.exports = __webpack_public_path__ + "static/media/us.fa563627.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/us.svg
// module id = 1379
// module chunks = 0